import validate from "/app/node_modules/.pnpm/nuxt@3.3.1_@types+node@18.15.7_eslint@8.36.0_optionator@0.9.4_rollup@3.18.0_sass@1.60.0_c7790f775ef7ee098c2326bd893577f4/node_modules/nuxt/dist/pages/runtime/validate.js";
import feature_45flags_45global from "/app/src/middleware/feature-flags.global.ts";
import redirect_45global from "/app/src/middleware/redirect.global.ts";
import router_45global from "/app/src/middleware/router.global.ts";
import settings_45global from "/app/src/middleware/settings.global.ts";
export const globalMiddleware = [
  validate,
  feature_45flags_45global,
  redirect_45global,
  router_45global,
  settings_45global
]
export const namedMiddleware = {
  auth: () => import("/app/src/middleware/auth.ts"),
  "not-auth": () => import("/app/src/middleware/not-auth.ts"),
  owner: () => import("/app/src/middleware/owner.ts")
}